package app.nestbridge.feature.main.ui

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual class MainShellBar actual constructor() : PlatformMainShellBar